/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List permissions
 */

export const listAccessAdministrationPermissionsQueryPerPageMax = 100;

export const ListAccessAdministrationPermissionsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listAccessAdministrationPermissionsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce.string().optional().describe("Free-text search query"),
});

export const listAccessAdministrationPermissionsResponseMetaTotalMin = 0;

export const ListAccessAdministrationPermissionsResponse = zod.object({
  items: zod.array(
    zod.object({
      permissionKey: zod.string(),
      label: zod.string(),
      description: zod.string(),
      category: zod.string(),
    }),
  ),
  meta: zod.object({
    total: zod
      .int()
      .min(listAccessAdministrationPermissionsResponseMetaTotalMin)
      .describe("Total count of items matching query ignoring pagination"),
    page: zod.int().min(1).describe("Current page number"),
    perPage: zod.int().min(1).describe("Number of items returned per page"),
  }),
});

/**
 * @summary Get permission
 */
export const GetAccessAdministrationPermissionResponse = zod.object({
  permissionKey: zod.string(),
  label: zod.string(),
  description: zod.string(),
  category: zod.string(),
});
